import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'vc-modal-sustainability',
  templateUrl: './modal-sustainability.component.html',
  styleUrls: ['./modal-sustainability.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalSustainabilityComponent implements OnInit {
  public localFilterTitle: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.localFilterTitle = data?.localFilterName || '';
  }

  ngOnInit(): void {}
}
